import React, { useEffect, useState } from "react";
import { IoIosAddCircleOutline } from "react-icons/io";
import AddTimeSheetPopup from "./AddTimeSheetPopup";
import ViewTimeSheetPopup from "./ViewTimeSheetPopup";
import axios from "axios";
import { FallingLines } from "react-loader-spinner";
import { LuPanelLeftOpen } from "react-icons/lu";
import { LuPanelRightOpen } from "react-icons/lu";
import user1 from "../../images/ic_no_person_photo.svg";
import Button from "@mui/joy/Button";
import { HiArrowDownTray } from "react-icons/hi2";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { base_url } from "../../utils/AxiosConfig";
import * as XLSX from "xlsx";
import { base_url_image_view_api } from "../../utils/ImageViewingAPI";
import SnackbarNotification from "../../utils/SnackbarNotification";

const Wps = () => {
  const [countOfSuccessGeneration, setCountOfSuccessGeneration] = useState(0);

  const startOfMonth = new Date();
  startOfMonth.setUTCDate(1);

  let initialStartingDate = format(startOfMonth, "dd-MM-yyyy");
  let initialEndingDate = format(new Date(), "dd-MM-yyyy");

  // const [timeSheetData, setTimeSheetData] = useState({
  //   startDate: initialStartingDate,
  //   endDate: initialEndingDate,
  // });

  const getLocalDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const [timeSheetData, setTimeSheetData] = useState(() => {
  const today = new Date();

  return {
    startDate: getLocalDate(
      new Date(today.getFullYear(), today.getMonth(), 1)
    ),
    endDate: getLocalDate(today),
  };
});

  const [branchListFromAPI, setBranchListFromAPI] = useState([]);
  const [branch, setBranch] = useState("-");
  const [deptListFromAPI, setDeptListFromAPI] = useState([]);
  const [dept, setDept] = useState("-");
  const [gradeListFromAPI, setGradeListFromAPI] = useState([]);
  const [grade, setGrade] = useState("-");
  const [isLoading, setIsLoading] = useState(false);

  // Handle input change
  const handleChangeDate = (e) => {
    const { name, value } = e.target;
    setTimeSheetData({
      ...timeSheetData,
      [name]: value,
    });
  };

  const handleChange = (event, eventType) => {
    switch (eventType) {
      case "division":
        setDivisionMUI(event.target.value);
    }
  };

  const getBranchList = async () => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DEPARTMENT/-`,
      // `${base_url}/api/MASTERLIST/CUBIX/DEPARTMENT/-`
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setBranchListFromAPI(newArray.map((i) => i.Description));
    } else {
      console.log("error");
    }
  };

  const getDeptList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DEPT/-`,
      // `${base_url}/api/MASTERLIST/CUBIX/DEPT/-`
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      console.log("dept newArray", newArray);
      setDeptListFromAPI(newArray.map((i) => i.Description));
    } else {
      console.log("error");
    }
  };

  const getGradeList = async (companyCode) => {
    const response = await axios.get(
      // `${base_url}/api/MASTERLIST/CUBIX/GRADE/-`
      `${base_url}/api/MASTERLIST/${companyCode}/GRADE/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      // console.log('newArrayList',newArray.map((i)=>i.Description))
      // console.log('newArray',newArray)
      setGradeListFromAPI(newArray.map((i) => i.Description));
      // setGrade(newArray);
    } else {
      console.log("error");
    }
  };

  const [selectedDivision, setSelectedDivision] = useState(null);
  const [selectedDivisionCode, setSelectedDivisionCode] = useState("-");

  const [divisionMUI, setDivisionMUI] = React.useState("");
  const storedUserDataArray = JSON.parse(
    localStorage.getItem("BondTimeuserDataArray"),
  );
  const storedLoginUser =
    JSON.parse(localStorage.getItem("BondTimeLoginUserData")) || [];
  let user = null;
  let companyCode = null;

  if (storedLoginUser) {
    user = storedLoginUser[0].salesman_name.trim();
  }

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  const [allBranchData, setAllBranchData] = useState([]);
  const [openViewModal, setOpenViewModal] = React.useState(false);

  const [data, setData] = useState();
  const [reset, setReset] = useState(false);
  const [loader, setLoader] = useState(true);
  const [popUpData, setpopUpData] = useState(null);
  const [Open, setOpen] = useState(false);
  const [companyCodeFromAPI, setCompanyCodeFromAPI] = useState(null);

  // pagination
  const [currentPage, SetcurrentPage] = useState(1);
  const recordsPerPage = 10;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = data?.slice(firstIndex, lastIndex);
  const npage = Math.ceil(data?.length / recordsPerPage);
  const numbers = Array.from({ length: npage }, (_, i) => i + 1);

  const fetchProfilePic = (ImagePath) => {
    const filePath = ImagePath.replace(/\\/g, "/");
    const fileName = filePath.split("/").pop(); // Extracts the last part (filename with extension)

    // Construct the full URL for the image
    return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
  };

  useEffect(() => {
    const getData = async () => {
      try {
        const storedUserDataArray =
          JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
        let companyCode = null;

        if (storedUserDataArray) {
          companyCode = storedUserDataArray[0].cmpcode;
          setCompanyCodeFromAPI(storedUserDataArray[0].cmpcode);
        }

        const response = await axios.get(
          `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/ALL/ALL/ALL/ALL`,
        );
        if (response?.data) {
          setData(response.data);

          setReset(false);
        }
      } catch (error) {
        console.error("PersonalInfoListerror:", error);
      }
    };

    // getData();
    // fetchPayrollData(companyCode);
    getBranchList(companyCode);
    getDeptList(companyCode);
    getGradeList(companyCode);
  }, []);

  const getWPSData = () => {
    setLoader(true);
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    // let apiWPSUrl = `${base_url}/api/WPSGen/CUBIX/-/-/${timeSheetData.startDate}/${timeSheetData.endDate}`
    //  `${base_url}/api/Payroll/CUBIX/${payslipStartDate}/${payslipEndDate}/${branch}/${dept}/${grade}`

    // let apiWPSUrl = `${base_url}/api/WPSGen/CUBIX/${timeSheetData.startDate}/${timeSheetData.endDate}/${branch}/${dept}/${grade}`
    let apiWPSUrl = `${base_url}/api/WPSGen/${companyCode}/${timeSheetData.startDate}/${timeSheetData.endDate}/${branch}/${dept}/${grade}`;

    console.log("apiUrl timesheet ", apiWPSUrl);

    axios
      .get(apiWPSUrl)
      .then((res) => {
        // setIsCallingAPI(false)
        console.log("res -->", res.data);

        setData(res.data);
        setLoader(false);
        // showSnackbar('success', 'WPS Data Fetched Succesfully');
      })
      .catch((err) => {
        console.log("getWPSDataErr", err);
        // toast.error('Some Error Occured')
        showSnackbar("error", "Some Error Occured");
        setLoader(false);

        // setIsCallingAPI(false)
      });
  };

  const downloadExcel = () => {
    // Convert the API data to a worksheet
    const ws = XLSX.utils.json_to_sheet(data);

    // Create a new workbook and append the worksheet to it
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Data");

    // Export the workbook to Excel and trigger a download
    XLSX.writeFile(wb, "data.xlsx");
  };

  const handleExport = () => {
    const columns = [
      { field: "SL NO", headerName: "SL NO" },
      { field: ["Column A"], headerName: "Column A" },
      { field: ["Column B"], headerName: "Column B" },
      { field: ["Column C"], headerName: "Column C" },
      { field: ["Column D"], headerName: "Column D" },
      { field: ["Column E"], headerName: "Column E" },
      { field: ["Column F"], headerName: "Column F" },
      { field: ["Column G"], headerName: "Column G" },
      { field: ["Column H"], headerName: "Column H" },
      { field: ["Column I"], headerName: "Column I" },
      { field: ["Column J"], headerName: "Column J" },

    ];

    exportToCSV(columns, records, "WPS_Report");
  };

  const exportToCSV = (columns, exportData, exportFileName = "export") => {
    if (!columns || !exportData || exportData.length === 0) return;

    const headerRow = columns.map((col) => col.headerName);

    const dataRows = exportData.map((row, index) =>
      columns.map((col) => {
        if (col.field === "SL NO") return index + 1;

        let value = row[col.field] ?? "";

        return `"${String(value).replace(/"/g, '""')}"`;
      }),
    );

    const csvContent = [headerRow, ...dataRows]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `${exportFileName}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  useEffect(() => {
    // Call getWPSData only if all dependencies are available
    if (base_url && timeSheetData?.startDate && timeSheetData?.endDate) {
      getWPSData();
    }
  }, [base_url]);

  useEffect(() => {
    if (data) {
      setLoader(false);
    }
  }, [data]);

  const fetchAllBranchData = async () => {
    try {
      const response = await axios.get(
        `${base_url}/api/MasterCount/${companyCode}/BRANCH/${user}/-`,
      );

      if (response.status === 200) {
        setAllBranchData(response.data);
      }
    } catch (error) {
      console.log("fetchAllBranchDataErr", error);
    }
  };

  useEffect(() => {
    fetchAllBranchData();
  }, []);

  const callGenerateTimeSheetAPI = async () => {
    for (let i = 0; i < records?.length; i++) {
      setIsLoading(true);

      try {
        const payload = [
          {
            mode: "ENTRY",
            cmpcode: companyCode,
            Empid: records[i]?.EmpId,
            StartDate: timeSheetData.startDate,
            EndDate: timeSheetData.endDate,
            deptno: selectedDivisionCode,
            jobcode: "-",
          },
        ];

        console.log("payload ", payload);

        const response = await axios.post(
          `${base_url}/api/TimesheetReg`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        if (response.status === 200) {
          setCountOfSuccessGeneration((prev) => prev + 1);

          setTimeSheetData({
            startDate: "",
            endDate: "",
          });
        } else {
          //toast.error("Failed to submit timesheet.");
        }
      } catch (error) {
        //toast.error("An error occurred while submitting timesheet.");
      } finally {
        setIsLoading(false);
      }
    }
  };

  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const showSnackbar = (severity, message) => {
    setSnackbar({ open: true, severity, message });
  };

  const handleClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <div className="container">
      <div className="flex  justify-between items-center ">
        <div className="row">
          {/* <div className="col-6 d-flex align-items-center justify-content-between">
            <div>
              <h6 className=" text-2xl font-bold text-gray-600 flex  justify-start items-center">

                <span>WPS</span>
              </h6>
            </div>
        </div> */}
          <div className="flex justify-left items-center ">
            <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
            <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4">
              {/* <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-[#2663EB] to-blue-700 text-white shadow-lg">
      <MdPersonAddAlt className="w-7 h-7" />
      </span> */}
              <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
                WPS
              </span>
            </h6>
          </div>

          {/* <div className="col-6">
          <div className="text-end">
            {Open === true ? <>< LuPanelRightOpen onClick={() => setOpen(false)} /></> : null}
            {Open === false ? <><LuPanelLeftOpen onClick={() => setOpen(true)} /></> : null}
          </div>
        </div> */}
        </div>

        <div className="flex items-end justify-center gap-4 mb-4">
          {/* <div className="flex justify-center items-end gap-4 "> */}
          {/* Branch Select */}
          <div className="flex flex-col">
            <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-1">
              Branch
            </label>
            <select
              value={branch}
              onChange={(e) => setBranch(e.target.value)}
              className="w-[180px] px-3 py-2 rounded-lg border border-slate-300 text-sm text-slate-900 bg-white appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">None</option>
              {branchListFromAPI?.map((b, i) => (
                <option key={i} value={b}>{b}</option>
              ))}
            </select>
          </div>

          {/* Department Select */}
          <div className="flex flex-col">
            <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-1">
              Department
            </label>
            <select
              value={dept}
              onChange={(e) => setDept(e.target.value)}
              className="w-[180px] px-3 py-2 rounded-lg border border-slate-300 text-sm text-slate-900 bg-white appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">None</option>
              {deptListFromAPI?.map((d, i) => (
                <option key={i} value={d}>{d}</option>
              ))}
            </select>
          </div>

          {/* Grade Select */}
          <div className="flex flex-col">
            <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-1">
              Grade
            </label>
            <select
              value={grade}
              onChange={(e) => setGrade(e.target.value)}
              className="w-[180px] px-3 py-2 rounded-lg border border-slate-300 text-sm text-slate-900 bg-white appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">None</option>
              {gradeListFromAPI?.map((g, i) => (
                <option key={i} value={g}>{g}</option>
              ))}
            </select>
          </div>

          <div className="d-flex  ">
            <div className="ml-4">
              <label
                for="exampleInputEmail1"
                class="form-label fs-small text-secondary"
              >
                Start Date
              </label>
              <input
                type="date"
                class="form-control"
                id="startDate"
                name="startDate"
                value={timeSheetData.startDate}
                onChange={handleChangeDate}
                max={new Date().toISOString().split("T")[0]}
              />
            </div>

            <div class="ms-2">
              <label
                for="exampleInputEmail1"
                class="form-label fs-small text-secondary"
              >
                End Date
              </label>
              <input
                type="date"
                class="form-control"
                id="endDate"
                name="endDate"
                value={timeSheetData.endDate}
                onChange={handleChangeDate}
                max={new Date().toISOString().split("T")[0]}
              />
            </div>
          </div>

          

          <button
            onClick={() => getWPSData()}
            className="btn btn-sm  mx-4"
            style={{ backgroundColor: "#bc5090", color: "#ffffff" }}
          >
            View
          </button>

          <div className="flex items-center gap-2">
            {/* <button className='dash-btn' style={{ */}
            <button
              className="flex items-center gap-2 cursor-pointer bg-blue-500 px-2 py-2 rounded text-white text-xs"
              style={{
                width: "140px",
              }}
              onClick={downloadExcel}
            >
              <HiArrowDownTray className="text-sm" />

              Download Excel
            </button>

            <button
              disabled={!records?.length}
              onClick={handleExport}
              className={`flex items-center gap-2 px-3 py-2 text-xs rounded-md text-white transition-all duration-200 shadow-sm
                            ${!records?.length
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-emerald-600 hover:bg-emerald-700"
                }
                            `}
            >
              <HiArrowDownTray className="text-sm" />
              Export CSV
            </button>
          </div>
        </div>
      </div>
      {/* <div className='m-2'>Number Of Successful Generation
        <span className='ms-2' style={{ fontWeight: "bold" }}>{countOfSuccessGeneration}</span>
      </div> */}

      {/* <div className={Open ? "table scroll" : "table scroll"}> */}
      <div>
        {records ? (
          <>
            {/* <table class="table"> */}
            <table className="shadow-sm min-w-full bg-white rounded-sm border border-gray-300 text-xs ">
              <thead>
                <tr className="bg-[#2663EB] text-white">
                  <th className="px-2 py-1  font-normal">Column A</th>
                  <th className="px-2 py-1  font-normal">Column B</th>
                  <th className="px-2 py-1  font-normal">Column C</th>
                  <th className="px-2 py-1  font-normal">Column D</th>
                  <th className="px-2 py-1  font-normal">Column E</th>
                  <th className="px-2 py-1  font-normal">Column F</th>
                  <th className="px-2 py-1  font-normal">Column G</th>
                  <th className="px-2 py-1  font-normal">Column H</th>
                  <th className="px-2 py-1  font-normal">Column I</th>
                  <th className="px-2 py-1  font-normal">Column J</th>

                </tr>
              </thead>
              <tbody>
                {records
                  ? records?.map((d, i) => (
                    <>
                      {/* <tr key={i} className="dataTr"> */}
                      <tr key={i} className="">
                        <td className="px-2 py-1 border">{d["Column A"]}</td>
                        <td className="px-2 py-1 border">{d["Column B"]}</td>
                        <td className="px-2 py-1 border">{d["Column C"]}</td>
                        <td className="px-2 py-1 border">{d["Column D"]}</td>
                        <td className="px-2 py-1 border">{d["Column E"]}</td>
                        <td className="px-2 py-1 border">{d["Column F"]}</td>
                        <td className="px-2 py-1 border">{d["Column G"]}</td>
                        <td className="px-2 py-1 border">{d["COLUMN H"]}</td>
                        <td className="px-2 py-1 border">{d["COLUMN I"]}</td>
                        <td className="px-2 py-1 border">{d["COLUMN J"]}</td>

                      </tr>
                    </>
                  ))
                  : null}
              </tbody>
            </table>
          </>
        ) : null}
      </div>
      {records ? (
        <>
          <div className="pagination-div mt-4">
            <div className="text-end">
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <li class="page-item">
                    {currentPage !== 1 ? (
                      <button class="page-link" href="#" onClick={prePage}>
                        Previous
                      </button>
                    ) : (
                      ""
                    )}
                  </li>
                  {numbers.map((n, i) => (
                    <li
                      className={`page-item  ${currentPage === n ? "active" : ""
                        }`}
                      key={i}
                    >
                      <button
                        // className="page-link bg-red-100"
                        className="page-link rounded"
                        onClick={() => changeCPage(n)}
                        href="#"
                      >
                        {n}
                      </button>
                    </li>
                  ))}

                  <li class="page-item">
                    {currentPage !== numbers[numbers.length - 1] ? (
                      <button class="page-link" href="#" onClick={nextPage}>
                        Next
                      </button>
                    ) : null}
                  </li>
                </ul>
              </nav>
            </div>
            <SnackbarNotification
              open={snackbar.open}
              severity={snackbar.severity}
              message={snackbar.message}
              onClose={handleClose}
            />
          </div>
        </>
      ) : null}
      <AddTimeSheetPopup popUpData={popUpData} />
      {popUpData && (
        <ViewTimeSheetPopup
          popUpData={popUpData}
          setOpenViewModal={setOpenViewModal}
          openViewModal={openViewModal}
          setpopUpData={setpopUpData}
        />
      )}

      <div className="table-nodata-img mtd">
        {loader ? (
          <>
            {" "}
            <div className="table-nodata-img">
              <div className="center">
                <p className="text-center pt-5">
                  Please Wait Loading Data... &nbsp;
                  <FallingLines />
                </p>
              </div>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
  function prePage() {
    if (currentPage !== firstIndex) {
      SetcurrentPage(currentPage - 1);
    }
  }
  function changeCPage(id) {
    SetcurrentPage(id);
  }

  function nextPage() {
    if (currentPage !== lastIndex) {
      SetcurrentPage(currentPage + 1);
    }
  }
};

export default Wps;
